import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/@nextui-org/card/dist/index.mjs");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/components/shared/WYSIWYG.jsx")